function getImageMetaDataFromSrc(src: string) {
    const ratioPath = src.split("/")[5]
    const isNewImageServiceUrl = new RegExp(/^\d+x\d+$/).test(ratioPath)

    if (!isNewImageServiceUrl) {
        return {
            width: 1200,
            height: 600,
            aspectRatio: 2 / 1,
        }
    }

    const [width, height] = ratioPath.split("x").map(Number)

    return {
        width,
        height,
        aspectRatio: width / height,
    }
}

export function computeImageDimensions(
    src: string,
    width?: number,
    height?: number,
    fill?: boolean
) {
    const imgMetaData = getImageMetaDataFromSrc(src)
    const { aspectRatio } = imgMetaData
    const widthIsNumber = typeof width === "number"
    const heightIsNumber = typeof height === "number"

    if (fill) {
        return undefined
    }

    if (widthIsNumber && heightIsNumber) {
        return {
            width,
            height,
        }
    }

    if (widthIsNumber && !heightIsNumber) {
        return {
            width,
            height: Math.ceil(width / aspectRatio),
        }
    }

    if (!widthIsNumber && heightIsNumber) {
        return {
            width: Math.ceil(height * aspectRatio),
            height,
        }
    }

    return {
        width: imgMetaData.width,
        height: imgMetaData.height,
    }
}
